import SelectableTabs from './SelectableTabs';
export default SelectableTabs;